export const languageOptions = [
  { label: "American Sign Language (ASL)", value: "ASL" },
  { label: "British Sign Language (BSL)", value: "BSL" },
  { label: "Indian Sign Language (ISL)", value: "ISL" },
  { label: "Auslan", value: "Auslan" },
  { label: "French Sign Language (LSF)", value: "LSF" },
  { label: "Other (Please specify below)", value: "Other" },
];
